module.exports = __webpack_public_path__ + "static/media/top_banner_pc_03.e708b8b7.webp";